import { z } from 'zod'

export const allEnumSchema = z.enum(['ALL'])
export const paginationOrderSchema = z.enum(['ASC', 'DESC'])
